import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Alert, Spinner, Row, Col, Image, Button, Badge } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { DataManager } from '../../core/data-manager';
import { ResourceManager } from '../../core/resource-manager';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import courseHeaderDefault from '../../assets/course-header.jpg';
import UltimePubblicazioni from '../../components/UltimePubblicazioni';


export default function Publication() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const { k } = useParams();
    const id = parseInt(k)

    const [data, setData] = useState(null);

    useEffect(() => {
        init()
    }, [id]);



    async function init() {
        var response = await DataManager.getItem('publication', id)
        if (response.success === 1) {
            if (response.body.length) {
                var t = response.body[0]
                setData(t)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
                setData({})
            }

            console.warn('publication', t)

        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
    }


    async function downloadFile(rD) {
        var response = await DataManager.searchItems('publication_user', 1, 1, { 'field': 'id', 'order': 'desc' }, '', [], [
            {
                fieldName: 'idPublication',
                type: 'value',
                value: id
            }
        ])
        if (response.success === 1 && response.body.length) {
            // record già presente
        }
        else {
            var resp = await DataManager.insertItem('publication_user', { idPublication: id, downloaded: '1' })
        }

        console.warn(rD)
        var url = ResourceManager.getFileUrl(rD.file, rD.file.entity)
        window.open(url, '_blank');

    }




    if (data) {
        var image = data.image ? ResourceManager.getFileUrl(data.image, 'publication') : courseHeaderDefault
        return (
            <>
                <Helmet>
                    <title>{LanguageProvider.get('header.pubblicazioni')}</title>
                </Helmet>

                <Container fluid style={{ "backgroundImage": `url('${image}')` }} className='course-header-bg p-0'>
                    <div className='course-header-parent'>
                        <Container fluid='md' className=' mb-5 text-light course-header'>

                            {errors.length > 0 &&
                                <Alert variant='danger'>
                                    {errors}
                                </Alert>
                            }
                            <Button style={{ border: 0, color: 'white', backgroundColor: 'transparent' }} className='mb-5' onClick={() => window.history.go(-1)}><FontAwesomeIcon icon='arrow-left' className='me-2'></FontAwesomeIcon>{LanguageProvider.get('defaults.back')}</Button>
                            <h4>{LanguageProvider.get('header.pubblicazioni')}</h4>
                            <h1>{data.title}</h1>
                            <Row style={{ maxWidth: 500 }} className='mt-5 mb-5 align-items-center'>
                                <Col xs={8}>
                                    {data.file ? (
                                        <Button variant='light' style={{ borderRadius: '20px', color: 'var(--primary-color)', borderColor: 'var(--primary-color)' }} className='px-3' onClick={() => downloadFile(data)}><FontAwesomeIcon icon='download' className='me-2'></FontAwesomeIcon>Scarica</Button>
                                    ) : null}
                                </Col>
                            </Row>

                        </Container>
                    </div>
                </Container>


                <Container fluid='md' className='mt-5 mb-5' >
                    <Row className='justify-content-between'>
                        <Col xs={12} md={5} >
                            <Image src={image} style={{ borderRadius: '20px', border: '1px solid #f7f7f7', width: '100%' }}></Image>
                        </Col>
                        <Col xs={12} md={7} >
                            <Row className='align-items-center p-3 mb-3' style={{ backgroundColor: '#f7f7f7', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                <Col xs={12}>
                                    <h5 className='mb-3'>{data.title}</h5>
                                    <p className='mb-5'>{moment(data.publicationDate).format('MMMM YYYY')}</p>
                                    <div className='ellipsis' dangerouslySetInnerHTML={{ __html: data.content }}></div>
                                    {data.paid === 1 ? <h5>Prezzo: {parseFloat(data.price).toFixed(2)} €</h5> : null}
                                    {data.file ? (
                                        <Button style={{ borderRadius: '20px', backgroundColor: 'var(--primary-color)' }} className='px-3 mt-3' onClick={() => downloadFile(data)}>Scarica in formato digitale<FontAwesomeIcon icon='download' className='ms-2'></FontAwesomeIcon></Button>
                                    ) : null}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>

                <UltimePubblicazioni />

            </>
        )

    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};